<li class="nav-item">
  <button (click)="openRedirectModal()" class="nav-link btn btn-secondary text-white mr-2"><i class="fa fa-share-square" aria-hidden="true"></i> {{ "redirectAction" | language }}</button>
</li>

<app-modal [id]="'redirectModal'">
  <span modal-title>{{ "redirectAction" | language }}</span>
  <div modal-body>
    <div *ngIf="error" class="alert alert-danger">{{ "redirectError" | language }}</div>
    <label>{{ "redirectInfo" | language }}</label>
    <h2 class="text-center bg-white border border-secondary text-dark pt-1 pb-1">{{ (_data["turn"] != null) ? _data["turn"]["label"] : _data["selectedTurn"]["label"] }}</h2>

    <ul class="nav nav-pills nav-fill mb-2" *ngIf="_data.configuration['queuedesk'] && !_data.configuration['useOnlyDeskRedirection']">
      <li class="nav-item cursor-pointer" (click)="actualFormType = 'queue'">
        <a class="nav-link" [ngClass]="{'active': actualFormType == 'queue'}"><i class="fa fa-code-fork" aria-hidden="true"></i> {{ "toQueue" | language }}</a>
      </li>
      <li class="nav-item cursor-pointer" (click)="actualFormType = 'desk'">
        <a class="nav-link" [ngClass]="{'active': actualFormType == 'desk'}"><i class="fa fa-user" aria-hidden="true"></i> {{ "toDesk" | language }}</a>
      </li>
    </ul>

    <div class="form-group" *ngIf="actualFormType == 'queue'">
      <label>{{ "toQueue" | language }}</label>
      <select class="form-control" (change)="changeQueue()" [(ngModel)]="redirectForm['queue']">
        <option disabled>{{ "chooseQueue" | language }}</option>
        <option [value]="q.id" *ngFor="let q of getActualQueues()">{{ q.title }}</option>
      </select>
    </div>

    <div class="form-group" *ngIf="actualFormType == 'desk'">
      <label>{{ "toDesk" | language }}</label>
      <select class="form-control" (change)="changeQueue()" [(ngModel)]="redirectForm['queue']">
        <option disabled>{{ "selectDeskToRedirect" | language }}</option>
        <option [value]="q.id" *ngFor="let q of getActualQueues()">{{ q.title }}</option>
      </select>
      <div class="alert alert-warning mt-2" *ngIf="redirectForm['qdesk_id'] && !_blogic.isDeskOnline(redirectForm['qdesk_id']) && redirectForm['queue'] != null">{{ "deskIsInactive" | language }}</div>
    </div>

    <div class="form-group" *ngIf="_data.configuration['redirectFirstAndLastMode']">
      <label>{{ "atPosition" | language }}</label>
      <select class="form-control" [(ngModel)]="redirectForm['mode']">
        <option value="S">{{ "arrivalOrder" | language }}</option>
        <option value="B">{{ "startOrder" | language }}</option>
        <option value="E">{{ "endOrder" | language }}</option>
      </select>
    </div>
    <div class="form-group" *ngIf="actualFormType == 'queue'">
      <label>{{ "indicatingAtype" | language }}</label>
      <select class="form-control" [(ngModel)]="redirectForm['atype']">
        <option disabled>{{ "selectAtype" | language }}</option>
        <option [value]="a.id" *ngFor="let a of atypes">{{ a.name }}</option>
      </select>
    </div>
    <div class="form-group">
      <label>{{ "observations" | language }}</label>
      <textarea class="form-control" [(ngModel)]="redirectForm['comment']"></textarea>
    </div>
    <div class="form-group">
      <label>{{ _data.ccodeTranslation }}</label>
      <input type="text" class="form-control" [(ngModel)]="cclient">
    </div>
    <div class="form-group">
      <label>Nombre de cliente</label>
      <input type="text" class="form-control" [(ngModel)]="nameClient">
    </div>
    <button (click)="redirect()" class="btn btn-success float-right" [disabled]="!redirectForm['queue'] || !redirectForm['mode']">{{ "accept" | language }}</button>
  </div>
</app-modal>
